module.exports = __webpack_public_path__ + "img/The-Studio.f4c33f09.jpg";